angular.module('env.data.repos.documents', [])

    .service("documentsRepository", function (rest) {
        var _this = this;
        var modelType = "DocumentModel";
        var modelDefinition = rest.getDefinition(modelType);

        /**
         * Get document by id
         * @param {string} id id of the document
         * @returns {!Promise.<RepresentationModel>} Promise of document
         */
        _this.getDocument = function (id) {
            return rest.map(modelDefinition).map(id).willReturn(modelType, id).get();
        };

        return _this;
    })

    .run(function (rest, requestCoupler, requestCouplerUtils) {
        var baserUrl = om.config.build.baseUrl;
        var modelUrl = rest.getDefinition("DocumentModel").getUrl();

        requestCoupler.addCoupler(requestCouplerUtils.createSimpleGetCollectionCoupler(modelUrl, baserUrl + "/" + modelUrl));
    })

;